module.exports = {
  accountSettingsURL: 'https://account.sdo.esoc.esa.int/settings',
}
